import AbstractPicker, { getDefaultProps } from './AbstractPicker';
import PropTypes from 'prop-types';
import popupProps from './popupProps';
export default class Picker extends AbstractPicker {
    constructor() {
        super(...arguments);
        this.popupProps = popupProps;
    }
}
Picker.defaultProps = getDefaultProps();
Picker.contextTypes = {
    antLocale: PropTypes.object,
};



// WEBPACK FOOTER //
// ./components/picker/index.tsx